import React from "react";

type IssueIconProps = {
    code: string,
    alt: string,
}
export const IssueSectionIcon: React.FC<IssueIconProps> = ({code, alt}) => {
    return <img src={`/assets/icons/singleCorrection/${code}.png`} alt={alt} />
}
